import { ThemeProvider, StyleSheetManager } from "styled-components";
import theme, { GlobalStyles } from "./styles/theme";
import AppRouter from "./routes";
import isPropValid from "@emotion/is-prop-valid";
import { UserProvider } from "./context/UserContext";
import { BottomSheetProvider } from "./context/BottomSheetContext";
import { LoadingProvider } from "./context/LoadingContext";
import { DeckProvider } from "./context/DeckContext";
import { SlotProvider } from "./context/SlotContext";
import { SocketProvider } from "./context/SocketContext";
import { BattleProvider } from "./context/BattleContext";
import UserProviderGate from "./context/UserContextProviderGate";
import { ToastContainer } from "react-toastify";
import { TokenProvider } from "./context/TokenContext";

function App() {
  return (
    <StyleSheetManager shouldForwardProp={(prop) => isPropValid(prop)}>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <UserProvider>
          <UserProviderGate>
            <SocketProvider>
              <LoadingProvider>
                <DeckProvider>
                  <BottomSheetProvider>
                    <ToastContainer
                      position="top-center"
                      autoClose={5000}
                      style={{ top: "64px", zIndex: 1050 }}
                      hideProgressBar={false}
                      newestOnTop={false}
                      closeOnClick={false}
                      rtl={false}
                      pauseOnFocusLoss
                      pauseOnHover
                      theme="dark"
                    />
                    <SlotProvider>
                      <BattleProvider>
                        <TokenProvider>
                          <AppRouter />
                        </TokenProvider>
                      </BattleProvider>
                    </SlotProvider>
                  </BottomSheetProvider>
                </DeckProvider>
              </LoadingProvider>
            </SocketProvider>
          </UserProviderGate>
        </UserProvider>
      </ThemeProvider>
    </StyleSheetManager>
  );
}

export default App;
